import React from "react";
import { styled } from "styled-components";

import Image from "../image";

import assistentSupportSvg from "../../assets/svgIcons/assistent_support.svg";
import appName from "../../assets/images/name-1.png";

const FooterOne = (props) => {
  const FooterOneWrapper = styled.div`
    border: 0px solid black;
    display: flex;
    /* padding: 10px; */
    align-items: center;
    justify-content: space-between;
    .poweredby {
      padding: 5px 0px;
      margin: 0px;
      color: gray;
    }
  `;
  return (
    <FooterOneWrapper className="px-lg-5 py-2">
      <div>
        <p className="poweredby sm-text">Powered by</p>
        <div>
          <Image src={appName} />
        </div>
      </div>
      <div className={`d-flex align-items-end`}>
        <div className={`me-3`}>
          <Image src={assistentSupportSvg} />
        </div>
        <div>
          <p className={`light-text md-text m-0`}>For assisstance</p>
          <p className={`md-text m-0`}>support@peoplex.tech</p>
        </div>
      </div>
    </FooterOneWrapper>
  );
};

export default FooterOne;
